/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation } from '@tanstack/react-query'
import type {
    MutationFunction,
    QueryClient,
    UseMutationOptions,
    UseMutationResult,
} from '@tanstack/react-query'

import type {
    CommentResponseDTO,
    DeleteRequestJobsFilesByIdCommentsByJobUuidAndFileUuidAndCommentUuidParams,
    HTTPValidationErrorDTO,
    PostRequestJobsFilesByIdCommentsByJobUuidAndFileUuidParams,
    PutRequestJobsFilesByIdCommentsByJobUuidAndFileUuidAndCommentUuidParams,
} from '../../model'

import { customInstance } from '../../../customInstance'
import type { ErrorType } from '../../../customInstance'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * adds a comment to a file.

 * @summary Post Comment
 */
export const postRequestJobsFilesByIdCommentsByJobUuidAndFileUuid = (
    jobUuid: string,
    fileUuid: string,
    params: PostRequestJobsFilesByIdCommentsByJobUuidAndFileUuidParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<CommentResponseDTO>(
        {
            url: `/jobs/${encodeURIComponent(String(jobUuid))}/files_by_id/${encodeURIComponent(String(fileUuid))}/comments`,
            method: 'POST',
            params,
            signal,
        },
        options,
    )
}

export const getPostRequestJobsFilesByIdCommentsByJobUuidAndFileUuidMutationOptions =
    <
        TError = ErrorType<void | HTTPValidationErrorDTO>,
        TContext = unknown,
    >(options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<
                    typeof postRequestJobsFilesByIdCommentsByJobUuidAndFileUuid
                >
            >,
            TError,
            {
                jobUuid: string
                fileUuid: string
                params: PostRequestJobsFilesByIdCommentsByJobUuidAndFileUuidParams
            },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    }): UseMutationOptions<
        Awaited<
            ReturnType<
                typeof postRequestJobsFilesByIdCommentsByJobUuidAndFileUuid
            >
        >,
        TError,
        {
            jobUuid: string
            fileUuid: string
            params: PostRequestJobsFilesByIdCommentsByJobUuidAndFileUuidParams
        },
        TContext
    > => {
        const mutationKey = [
            'postRequestJobsFilesByIdCommentsByJobUuidAndFileUuid',
        ]
        const { mutation: mutationOptions, request: requestOptions } = options
            ? options.mutation &&
              'mutationKey' in options.mutation &&
              options.mutation.mutationKey
                ? options
                : { ...options, mutation: { ...options.mutation, mutationKey } }
            : { mutation: { mutationKey }, request: undefined }

        const mutationFn: MutationFunction<
            Awaited<
                ReturnType<
                    typeof postRequestJobsFilesByIdCommentsByJobUuidAndFileUuid
                >
            >,
            {
                jobUuid: string
                fileUuid: string
                params: PostRequestJobsFilesByIdCommentsByJobUuidAndFileUuidParams
            }
        > = (props) => {
            const { jobUuid, fileUuid, params } = props ?? {}

            return postRequestJobsFilesByIdCommentsByJobUuidAndFileUuid(
                jobUuid,
                fileUuid,
                params,
                requestOptions,
            )
        }

        return { mutationFn, ...mutationOptions }
    }

export type PostRequestJobsFilesByIdCommentsByJobUuidAndFileUuidMutationResult =
    NonNullable<
        Awaited<
            ReturnType<
                typeof postRequestJobsFilesByIdCommentsByJobUuidAndFileUuid
            >
        >
    >

export type PostRequestJobsFilesByIdCommentsByJobUuidAndFileUuidMutationError =
    ErrorType<void | HTTPValidationErrorDTO>

/**
 * @summary Post Comment
 */
export const usePostRequestJobsFilesByIdCommentsByJobUuidAndFileUuid = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<
                    typeof postRequestJobsFilesByIdCommentsByJobUuidAndFileUuid
                >
            >,
            TError,
            {
                jobUuid: string
                fileUuid: string
                params: PostRequestJobsFilesByIdCommentsByJobUuidAndFileUuidParams
            },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<
        ReturnType<typeof postRequestJobsFilesByIdCommentsByJobUuidAndFileUuid>
    >,
    TError,
    {
        jobUuid: string
        fileUuid: string
        params: PostRequestJobsFilesByIdCommentsByJobUuidAndFileUuidParams
    },
    TContext
> => {
    const mutationOptions =
        getPostRequestJobsFilesByIdCommentsByJobUuidAndFileUuidMutationOptions(
            options,
        )

    return useMutation(mutationOptions, queryClient)
}
/**
 * edit an existing comment

 * @summary Edit Comment
 */
export const putRequestJobsFilesByIdCommentsByJobUuidAndFileUuidAndCommentUuid =
    (
        jobUuid: string,
        fileUuid: string,
        commentUuid: string,
        params: PutRequestJobsFilesByIdCommentsByJobUuidAndFileUuidAndCommentUuidParams,
        options?: SecondParameter<typeof customInstance>,
    ) => {
        return customInstance<CommentResponseDTO>(
            {
                url: `/jobs/${encodeURIComponent(String(jobUuid))}/files_by_id/${encodeURIComponent(String(fileUuid))}/comments/${encodeURIComponent(String(commentUuid))}`,
                method: 'PUT',
                params,
            },
            options,
        )
    }

export const getPutRequestJobsFilesByIdCommentsByJobUuidAndFileUuidAndCommentUuidMutationOptions =
    <
        TError = ErrorType<void | HTTPValidationErrorDTO>,
        TContext = unknown,
    >(options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<
                    typeof putRequestJobsFilesByIdCommentsByJobUuidAndFileUuidAndCommentUuid
                >
            >,
            TError,
            {
                jobUuid: string
                fileUuid: string
                commentUuid: string
                params: PutRequestJobsFilesByIdCommentsByJobUuidAndFileUuidAndCommentUuidParams
            },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    }): UseMutationOptions<
        Awaited<
            ReturnType<
                typeof putRequestJobsFilesByIdCommentsByJobUuidAndFileUuidAndCommentUuid
            >
        >,
        TError,
        {
            jobUuid: string
            fileUuid: string
            commentUuid: string
            params: PutRequestJobsFilesByIdCommentsByJobUuidAndFileUuidAndCommentUuidParams
        },
        TContext
    > => {
        const mutationKey = [
            'putRequestJobsFilesByIdCommentsByJobUuidAndFileUuidAndCommentUuid',
        ]
        const { mutation: mutationOptions, request: requestOptions } = options
            ? options.mutation &&
              'mutationKey' in options.mutation &&
              options.mutation.mutationKey
                ? options
                : { ...options, mutation: { ...options.mutation, mutationKey } }
            : { mutation: { mutationKey }, request: undefined }

        const mutationFn: MutationFunction<
            Awaited<
                ReturnType<
                    typeof putRequestJobsFilesByIdCommentsByJobUuidAndFileUuidAndCommentUuid
                >
            >,
            {
                jobUuid: string
                fileUuid: string
                commentUuid: string
                params: PutRequestJobsFilesByIdCommentsByJobUuidAndFileUuidAndCommentUuidParams
            }
        > = (props) => {
            const { jobUuid, fileUuid, commentUuid, params } = props ?? {}

            return putRequestJobsFilesByIdCommentsByJobUuidAndFileUuidAndCommentUuid(
                jobUuid,
                fileUuid,
                commentUuid,
                params,
                requestOptions,
            )
        }

        return { mutationFn, ...mutationOptions }
    }

export type PutRequestJobsFilesByIdCommentsByJobUuidAndFileUuidAndCommentUuidMutationResult =
    NonNullable<
        Awaited<
            ReturnType<
                typeof putRequestJobsFilesByIdCommentsByJobUuidAndFileUuidAndCommentUuid
            >
        >
    >

export type PutRequestJobsFilesByIdCommentsByJobUuidAndFileUuidAndCommentUuidMutationError =
    ErrorType<void | HTTPValidationErrorDTO>

/**
 * @summary Edit Comment
 */
export const usePutRequestJobsFilesByIdCommentsByJobUuidAndFileUuidAndCommentUuid =
    <TError = ErrorType<void | HTTPValidationErrorDTO>, TContext = unknown>(
        options?: {
            mutation?: UseMutationOptions<
                Awaited<
                    ReturnType<
                        typeof putRequestJobsFilesByIdCommentsByJobUuidAndFileUuidAndCommentUuid
                    >
                >,
                TError,
                {
                    jobUuid: string
                    fileUuid: string
                    commentUuid: string
                    params: PutRequestJobsFilesByIdCommentsByJobUuidAndFileUuidAndCommentUuidParams
                },
                TContext
            >
            request?: SecondParameter<typeof customInstance>
        },
        queryClient?: QueryClient,
    ): UseMutationResult<
        Awaited<
            ReturnType<
                typeof putRequestJobsFilesByIdCommentsByJobUuidAndFileUuidAndCommentUuid
            >
        >,
        TError,
        {
            jobUuid: string
            fileUuid: string
            commentUuid: string
            params: PutRequestJobsFilesByIdCommentsByJobUuidAndFileUuidAndCommentUuidParams
        },
        TContext
    > => {
        const mutationOptions =
            getPutRequestJobsFilesByIdCommentsByJobUuidAndFileUuidAndCommentUuidMutationOptions(
                options,
            )

        return useMutation(mutationOptions, queryClient)
    }
/**
 * delete an existing comment

 * @summary Delete Comment
 */
export const deleteRequestJobsFilesByIdCommentsByJobUuidAndFileUuidAndCommentUuid =
    (
        jobUuid: string,
        fileUuid: string,
        commentUuid: string,
        params: DeleteRequestJobsFilesByIdCommentsByJobUuidAndFileUuidAndCommentUuidParams,
        options?: SecondParameter<typeof customInstance>,
    ) => {
        return customInstance<CommentResponseDTO>(
            {
                url: `/jobs/${encodeURIComponent(String(jobUuid))}/files_by_id/${encodeURIComponent(String(fileUuid))}/comments/${encodeURIComponent(String(commentUuid))}`,
                method: 'DELETE',
                params,
            },
            options,
        )
    }

export const getDeleteRequestJobsFilesByIdCommentsByJobUuidAndFileUuidAndCommentUuidMutationOptions =
    <
        TError = ErrorType<void | HTTPValidationErrorDTO>,
        TContext = unknown,
    >(options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<
                    typeof deleteRequestJobsFilesByIdCommentsByJobUuidAndFileUuidAndCommentUuid
                >
            >,
            TError,
            {
                jobUuid: string
                fileUuid: string
                commentUuid: string
                params: DeleteRequestJobsFilesByIdCommentsByJobUuidAndFileUuidAndCommentUuidParams
            },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    }): UseMutationOptions<
        Awaited<
            ReturnType<
                typeof deleteRequestJobsFilesByIdCommentsByJobUuidAndFileUuidAndCommentUuid
            >
        >,
        TError,
        {
            jobUuid: string
            fileUuid: string
            commentUuid: string
            params: DeleteRequestJobsFilesByIdCommentsByJobUuidAndFileUuidAndCommentUuidParams
        },
        TContext
    > => {
        const mutationKey = [
            'deleteRequestJobsFilesByIdCommentsByJobUuidAndFileUuidAndCommentUuid',
        ]
        const { mutation: mutationOptions, request: requestOptions } = options
            ? options.mutation &&
              'mutationKey' in options.mutation &&
              options.mutation.mutationKey
                ? options
                : { ...options, mutation: { ...options.mutation, mutationKey } }
            : { mutation: { mutationKey }, request: undefined }

        const mutationFn: MutationFunction<
            Awaited<
                ReturnType<
                    typeof deleteRequestJobsFilesByIdCommentsByJobUuidAndFileUuidAndCommentUuid
                >
            >,
            {
                jobUuid: string
                fileUuid: string
                commentUuid: string
                params: DeleteRequestJobsFilesByIdCommentsByJobUuidAndFileUuidAndCommentUuidParams
            }
        > = (props) => {
            const { jobUuid, fileUuid, commentUuid, params } = props ?? {}

            return deleteRequestJobsFilesByIdCommentsByJobUuidAndFileUuidAndCommentUuid(
                jobUuid,
                fileUuid,
                commentUuid,
                params,
                requestOptions,
            )
        }

        return { mutationFn, ...mutationOptions }
    }

export type DeleteRequestJobsFilesByIdCommentsByJobUuidAndFileUuidAndCommentUuidMutationResult =
    NonNullable<
        Awaited<
            ReturnType<
                typeof deleteRequestJobsFilesByIdCommentsByJobUuidAndFileUuidAndCommentUuid
            >
        >
    >

export type DeleteRequestJobsFilesByIdCommentsByJobUuidAndFileUuidAndCommentUuidMutationError =
    ErrorType<void | HTTPValidationErrorDTO>

/**
 * @summary Delete Comment
 */
export const useDeleteRequestJobsFilesByIdCommentsByJobUuidAndFileUuidAndCommentUuid =
    <TError = ErrorType<void | HTTPValidationErrorDTO>, TContext = unknown>(
        options?: {
            mutation?: UseMutationOptions<
                Awaited<
                    ReturnType<
                        typeof deleteRequestJobsFilesByIdCommentsByJobUuidAndFileUuidAndCommentUuid
                    >
                >,
                TError,
                {
                    jobUuid: string
                    fileUuid: string
                    commentUuid: string
                    params: DeleteRequestJobsFilesByIdCommentsByJobUuidAndFileUuidAndCommentUuidParams
                },
                TContext
            >
            request?: SecondParameter<typeof customInstance>
        },
        queryClient?: QueryClient,
    ): UseMutationResult<
        Awaited<
            ReturnType<
                typeof deleteRequestJobsFilesByIdCommentsByJobUuidAndFileUuidAndCommentUuid
            >
        >,
        TError,
        {
            jobUuid: string
            fileUuid: string
            commentUuid: string
            params: DeleteRequestJobsFilesByIdCommentsByJobUuidAndFileUuidAndCommentUuidParams
        },
        TContext
    > => {
        const mutationOptions =
            getDeleteRequestJobsFilesByIdCommentsByJobUuidAndFileUuidAndCommentUuidMutationOptions(
                options,
            )

        return useMutation(mutationOptions, queryClient)
    }
